<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
    <b-form-row class="vh-100 vw-100 row-login" @keyup.enter="entrar">
        <b-col sm="5" class="d-flex justify-content-center align-items-center left-login">
            <div class="col-8">
                <b-card bg-variant="secundary">
                    <b-col sm="12" class="d-flex justify-content-center align-items-center">
                        <img src="../assets/img/Logo_spalm_azul.svg" class="img-login"
                            style="max-width:300px; padding: 15px; width: 100%" />
                    </b-col>

                    <b-form @keyup.enter="login">
                        <b-form-group label="Usuário">
                            <b-input v-model="form.username" />
                        </b-form-group>

                        <b-form-group label="Senha" class="senha-wrapper">
                            <b-form-input :type="mostrarSenha ? 'text' : 'password'" v-model="form.password"
                                class="form-control-senha" />
                            <b-button @click="mostrarSenha = !mostrarSenha" id="togglePasswordBtn" class="btn-ver-senha"
                                variant="link">
                                <b-icon :icon="mostrarSenha ? 'eye-slash' : 'eye'" />
                            </b-button>
                        </b-form-group>


                        <span @click="mostrarEsqueceuASenha" class="esqueceuSenha">Esqueceu a senha?</span>


                    </b-form>

                    <div class="text-right" slot="footer">
                        <b-button type="submit" variant="primary" block @click="entrar">Entrar</b-button>
                    </div>
                </b-card>

                <div class="text-left">
                    <span style="color: red; font-size: smaller; font-weight: 400;">DEBUG: OFF / AMBIENTE:
                        Apresentação</span>
                </div>
                <div style="color: #f4f4f4;">Versão: 2.4.0</div>
            </div>
        </b-col>
        <b-col sm="7" class="d-flex justify-content-center align-items-center">
            <img src="../assets/img/logos/login.svg" style=" width: 100% ; max-height:100vh" class="img-login" />
        </b-col>

        <b-modal size="md" button-size="sm" hide-footer v-if="mostrarModal" v-model="mostrarModal" :title="'Nova Senha'"
            @hidden="fechar">


            <b-form-group label="Nova Senha:*">
                <b-input type="password" v-model="form.newPassword" />
            </b-form-group>

            <b-form-group label="Nova Senha Novamente:*">
                <b-input type="password" v-model="form.newPasswordAgain" />
            </b-form-group>


            <b-button variant="primary" block @click="alterar">Alterar Senha</b-button>


        </b-modal>


        <b-modal id="modalRecuperarSenha" size="md" button-size="sm" hide-footer v-if="isMostrarEsqueceuASenha"
            v-model="isMostrarEsqueceuASenha" :title="'Nova Senha'" @hidden="fechar">

            <b-form-group label="Código de Verificação:*">
                <b-input type="text" v-model="form.codigoRecuperacaoUsuario" />
            </b-form-group>


            <b-form-group label="Nova Senha:*">
                <b-input type="password" v-model="form.newPassword" />
            </b-form-group>

            <b-form-group label="Nova Senha Novamente:*">
                <b-input type="password" v-model="form.newPasswordAgain" />
            </b-form-group>


            <b-button variant="primary" block @click="confirmarEsquecer">Alterar Senha</b-button>


        </b-modal>


        <b-modal size="xl" button-size="sm" hide-footer v-if="mostrarMudancas" v-model="mostrarMudancas"
            :title="'Mudanças Recentes'" @hidden="fecharMudancas">

            <b-table responsive class="mt-2" small :busy="this.busy" :items="mudancas" :fields="this.tableFields"
                show-empty>
                <template #empty>
                    <p>Nenhum registro encontrado</p>
                </template>

                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Carregando...</strong>
                    </div>
                </template>

                <template #cell(data)="data">
                    {{ formatDate(data.item.data) }}
                </template>
            </b-table>

            <b-button variant="primary" block @click="fecharMudancas">fechar</b-button>



        </b-modal>

    </b-form-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService"

import { login, primeiroLogin, alterarSenha } from "@/core/auth";

export default {
    isAuthenticated: false,
    comments: {
    },
    data() {
        return {
            isMostrarEsqueceuASenha: false,
            busy: false,
            mudancas: [],
            mostrarMudancas: false,
            mostrarModal: false,
            mostrarSenha: false,
            form: {
                username: "",
                password: "",
                newPassword: "",
                newPasswordAgain: "",
                codigoRecuperacaoUsuario: ""
            },
        };
    },

    validations: {
        form: {
            username: {
                required,
            },
            password: {
                required,
            },
        },
    },

    computed: {
        formIsValid() {
            return !this.$v.$invalid;
        },
        tableFields() {
            return [
                {
                    key: "descricao",
                    label: "Mudança",
                },
                {
                    key: "data",
                    label: "Data",
                },
            ]
        },

    },
    async beforeMount() {
    },

    methods: {
        async mostrarEsqueceuASenha() {

            if (this.form.username == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o usuário",
                });
                return;
            }
            try {
                await new ResourceService("/api/login").put("esqueceu-a-senha", { username: this.form.username });
                this.$notify({
                    type: "success",
                    message: "Foi enviado um código de verificação para o email cadastrado",
                });

                this.isMostrarEsqueceuASenha = true

                this.form.codigoRecuperacaoUsuario = "";
                this.form.newPassword = "";
                this.form.newPasswordAgain = "";

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
        },
        rotearDashboard() {
            let roteador = this.$router;

            roteador.push("/dashboard");

            setTimeout(() => {
                location.reload();

            }, 500)


        },
        formatDate(dateString) {
            if (!dateString) return "N/A";

            const [datePart] = dateString.split("T");
            const [year, month, day] = datePart.split("-");

            return `${day}/${month}/${year}`;
        },
        async carregarMudancas() {

            this.busy = true;

            var { data } = await new ResourceService("/api/sgu/usuarios").get('buscar-mudancas-nao-lidas');

            this.mudancas = data;
            this.busy = false;

            if (this.mudancas.length == 0)
                this.rotearDashboard();
            else
                this.mostrarMudancas = true;


        },
        async handleLogin() {
            var { data } = await new ResourceService("/api/configuracoes-sistema").get('280');



            if (data.valorPropriedade == 1) {
                this.carregarMudancas();
            } else {
                this.rotearDashboard();
            }

        },
        async fecharMudancas() {
            this.busy = true;
            await new ResourceService("/api/sgu/usuarios").put('atualizar-mudancas-nao-lidas');
            this.busy = false;
            this.mostrarMudancas = false;
            this.rotearDashboard();

        },
        async alterar() {

            if (this.form.newPassword == null || this.form.newPassword == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a nova senha",
                });
                return;

            }

            if (this.form.newPasswordAgain == null || this.form.newPasswordAgain == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a nova senha novamente",
                });

                return;

            }

            if (this.form.newPasswordAgain != this.form.newPassword) {
                this.$notify({
                    type: "danger",
                    message: "As duas senhas precisam ser iguais",
                });

                return;

            }

            await alterarSenha(this.form);
            this.$notify({
                type: "success",
                message: "A senha foi alterada com sucesso. Por favor, fazer o login novamente",
            });

            this.fechar();


        },

        async confirmarEsquecer() {

            if (this.form.codigoRecuperacaoUsuario == null || this.form.codigoRecuperacaoUsuario == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o código de confirmação",
                });
                return;

            }



            if (this.form.newPassword == null || this.form.newPassword == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a nova senha",
                });
                return;

            }

            if (this.form.newPasswordAgain == null || this.form.newPasswordAgain == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a nova senha novamente",
                });

                return;

            }

            if (this.form.newPasswordAgain != this.form.newPassword) {
                this.$notify({
                    type: "danger",
                    message: "As duas senhas precisam ser iguais",
                });

                return;

            }

            try {
                await new ResourceService("/api/login").put("alterar-senha", this.form);

                this.$notify({
                    type: "success",
                    message: "A senha foi alterada com sucesso. Por favor, fazer o login novamente",
                });

                this.fechar();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
        },
        fechar() {
            this.mostrarModal = false;
            this.isMostrarEsqueceuASenha = false;
        },
        async entrar() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Os campos de Usuário e Senha são obrigatórios.",
                });
                return;
            }

            try {

                var data = await primeiroLogin(this.form);
                if (!data) {
                    this.mostrarModal = true;
                } else {

                    await login(this.form);

                    this.handleLogin();

                }

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response ? error.response.data : 'Não foi possível se conectar ao servidor',
                });


            }



        },
    },
};
</script>

<style>
*,
/*resetar o estilo da página*/
*::after *::before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-decoration: none;
}

.row-login {
    margin-left: 0;
}

.left-login {
    background-color: #0D3B66;
}

.title-login {
    font-weight: bold;
}

.esqueceuSenha {
    margin-left: 10px;
    color: blue;
    cursor: pointer;
}
</style>
